import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
    function viewPolicy() {
        window.location.href = window.location.origin + '/policy.html';
    }

    return (
        <div className="policy-link" onClick={() => viewPolicy()}>View our privacy policy.</div>
    )
}
      

